import JobProfileListContainer from './JobProfileListContainer';
import JobProfileSurveyListContainer from './jps/JobProfileSurveyListContainer';
import JobProfileDetailContainer from './details/JobProfileDetailContainer';
import JPSDetailContainer from '../JPSRespondentDetail/JPSDetailContainer';
import NewJobProfile from './new/NewJobProfile';
import SuperProfiles from './super-profile/SuperProfiles';
import AddSuperProfile from './super-profile/AddSuperProfile';
import UpdateSuperProfile from './super-profile/UpdateSuperProfile';

const jobProfileRoutes = [
  {
    path: '/accounts/:aid/job-profiles/',
    component: JobProfileListContainer,
    exact: true,
  },
  { path: '/accounts/:aid/job-profiles/new', component: NewJobProfile },
  {
    path: '/accounts/:aid/job-profiles/:jobProfileId/surveys',
    component: JobProfileSurveyListContainer,
    exact: true,
  },
  {
    path: '/accounts/:aid/super-profiles/',
    component: SuperProfiles,
    exact: true,
  },
  { path: '/accounts/:aid/super-profiles/new', component: AddSuperProfile },
  {
    path: '/accounts/:aid/super-profiles/:superProfileId',
    component: UpdateSuperProfile,
    exact: true,
  },
  {
    path: '/accounts/:aid/jps/:jpsRespondentId',
    component: JPSDetailContainer,
  },
  {
    path: '/accounts/:aid/job-profiles/:jobProfileId',
    component: JobProfileDetailContainer,
    exact: true,
  },
];

export default jobProfileRoutes;
